import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import Lara from '@primeuix/themes/lara';
import Material from '@primeuix/themes/material';

interface DemoOption {
  label: string;
  value: string;
}

interface ThemeOption extends DemoOption {
  preset: any;
  dark?: boolean;
}

@Component({
  selector: 'app-prime-ui-demo',
  standalone: true,
  imports: [CommonModule, FormsModule, SelectModule, ButtonModule, InputTextModule],
  templateUrl: './prime-ui-demo.component.html',
  styleUrl: './prime-ui-demo.component.scss',
})
export class PrimeUiDemoComponent {
  statusOptions: DemoOption[] = [
    { label: 'Open', value: 'open' },
    { label: 'In Progress', value: 'in-progress' },
    { label: 'Blocked', value: 'blocked' },
    { label: 'Complete', value: 'complete' },
  ];

  projectOptions: DemoOption[] = [
    { label: 'Inbox', value: 'inbox' },
    { label: 'Personal', value: 'personal' },
    { label: 'Work', value: 'work' },
    { label: 'Next Actions', value: 'next-actions' },
    { label: 'Someday', value: 'someday' },
  ];

  themeOptions: ThemeOption[] = [
    { label: 'Aura Light', value: 'aura-light', preset: Aura },
    { label: 'Aura Dark', value: 'aura-dark', preset: Aura, dark: true },
    { label: 'Lara', value: 'lara', preset: Lara },
    { label: 'Material', value: 'material', preset: Material },
  ];

  selectedStatus: DemoOption | null = this.statusOptions[0];
  selectedProject: DemoOption | null = this.projectOptions[0];
  selectedTheme: ThemeOption | null = this.themeOptions[0];
  keyword = '';

  constructor(private primeNG: PrimeNG) {
    this.applyTheme(this.selectedTheme);
  }

  cycleTheme(): void {
    const currentIndex = this.themeOptions.findIndex((opt) => opt.value === this.selectedTheme?.value);
    const nextIndex = (currentIndex + 1) % this.themeOptions.length;
    this.selectedTheme = this.themeOptions[nextIndex];
    this.applyTheme(this.selectedTheme);
  }

  onThemeSelected(option: ThemeOption | null): void {
    this.selectedTheme = option;
    this.applyTheme(option);
  }

  private applyTheme(option: ThemeOption | null): void {
    if (!option) {
      return;
    }

    this.primeNG.setConfig({
      theme: {
        preset: option.preset,
        options: { darkModeSelector: '.p-dark' },
      },
    });

    document.documentElement.classList.toggle('p-dark', !!option.dark);
  }
}
